<div class="details-container">
  <div class="left-column">
    <button class="back-button" mat-button routerLink="" [routerLink]="['../']">
      <mat-icon>keyboard_backspace</mat-icon>
    </button>
    <img [src]="'assets/img/' + imagenes[producto.idProducto.toString()]" alt="{{ nombres[producto.idProducto.toString()] }}">
  </div>
  <div class="right-column">
    <h2>{{ nombres[producto.idProducto.toString()] }}</h2>
    <p>{{ producto.descripcion }}</p>
    <p><strong>Precio:</strong> $ <strong>{{ producto.precioPublico }}</strong> MX</p>
    <div class="input-container">
      <label for="cantidad">Cantidad:</label>
      <input type="number" id="cantidad" value="1" min="1" max="1" step="1" class="small-input no-edit">
    </div>
    <button [routerLink]="['/pago-online', producto.idProducto]" class="buy-button">Comprar</button>
    <div class="note">
      Los productos estarán listos para entrega 15 días después de su compra.
    </div>
  </div>
</div>
